// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"5b9a701d","480":"d18933b9"}[chunkId] + ".chunk.js";
};